import { render, staticRenderFns } from "./hubin_outscan_details.vue?vue&type=template&id=593a97ce"
import script from "./hubin_outscan_details.vue?vue&type=script&lang=js"
export * from "./hubin_outscan_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports